import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for AccountList
export const AccountList = createSlice({
  name: "AccountList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_AccountList: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_AccountList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_AccountList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    List_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearDataaccount: (state) => {
      state.data = [];
    },
  },
});
export default AccountList.reducer;
export const {
  list_AccountList,
  success_api_call_AccountList,
  failure_api_call_AccountList,
  List_is_first,
  clearDataaccount,
} = AccountList.actions;
